import { render, staticRenderFns } from "./SamplingCoupons.vue?vue&type=template&id=14bf365e&scoped=true"
import script from "./SamplingCoupons.vue?vue&type=script&lang=js"
export * from "./SamplingCoupons.vue?vue&type=script&lang=js"
import style0 from "./SamplingCoupons.vue?vue&type=style&index=0&id=14bf365e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf365e",
  null
  
)

export default component.exports